const state = {
  MarketingCloudToken: "",
  userInfo: "",
  projects: [],
  currentProject: "",
  //用户登录信息
  loginForm: {},
};
const mutations = {
  SET_USERINFO(state, val) {
    state.MarketingCloudToken = val.token;
    state.userInfo = val.user;
  },
  SET_CURRENT_PROJECT(state, val) {
    state.currentProject = val;
  },
  SET_PROJECTS(state, val) {
    state.projects = val;
  },
  SET_INIT_USER(state) {
    state.MarketingCloudToken = "";
    state.userInfo = "";
    // state.loginForm = {};
    // state.projects = "";
    // state.currentProject = "";
  },
  SET_INIT_PROJECT(state) {
    state.projects = [];
    state.currentProject = "";
  },
  SET_LOGIN_FORM(state, payload) {
    state.loginForm = payload;
  },
  INIT_LOGIN_FORM(state) {
    state.loginForm = {};
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
